<p-menubar [model]="menuItems" [ngClass]="'shadow-2 surface-ground app-menubar'">
  <ng-template pTemplate="start">
    <div class="flex align-items-center gap-2 px-2">
      <img src="assets/images/logo-chatrandom.svg" alt="Logo PopMe" height="48" class="logo-mode" />
      <span class="font-bold text-lg">Chats Random!</span>
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    <div *ngIf="!pantallaPequena" class="flex align-items-center gap-3 px-3">
      <!-- Nombre de usuario -->
         <!-- Wallet (botón que lleva a tienda) -->
      <button pButton class="p-button-text p-button-sm coin-counter flex align-items-center gap-1 text-yellow-400"
        routerLink="/app/tienda" pTooltip="Ir a la tienda" tooltipPosition="top">
        <i-lucide [img]="Wallet" class="coin-icon"></i-lucide>
        <span class="ml-2 coin-value">{{ coins$ | async }}</span>
      </button>

      <!-- Regalos Recibidos con badge personalizado -->
      <div class="relative inline-block">
        <button pButton icon="pi pi-gift" class="p-button-text p-button-sm" routerLink="/app/regalos-recibidos">
        </button>

        <span *ngIf="regalosRecibidosNoVistos().length > 0" class="badge-notificacion">
          {{ regalosRecibidosNoVistos().length }}
        </span>
      </div>
      <!-- Logout -->
      <button pButton icon="pi pi-sign-out" class="p-button-text" (click)="logout()" pTooltip="Cerrar sesión"
        tooltipPosition="top">
      </button>
    </div>
  </ng-template>

</p-menubar>

<div class="p-3 sm:p-4 md:p-5 lg:p-6 xl:p-7 layout-wrapper min-h-screen">
  <router-outlet></router-outlet>
</div>